import { render, staticRenderFns } from "./PayablesReceivables.vue?vue&type=template&id=d44632b8&scoped=true&"
import script from "./PayablesReceivables.vue?vue&type=script&lang=js&"
export * from "./PayablesReceivables.vue?vue&type=script&lang=js&"
import style0 from "./PayablesReceivables.vue?vue&type=style&index=0&id=d44632b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44632b8",
  null
  
)

export default component.exports